export const getBankAvailability = availability => {
  const { enabled, active } = availability;

  return enabled.data && active.data;
};
